<template>
  <div class="phone-container">
    <Tubiao></Tubiao>
    <div class="bodytitle"><span>{{ paper.tName }}</span></div>
    <div class="renge">
      <!-- <span>总得分：{{ score }}分</span> -->
      <span class="sptxt">您的易受骗程度：</span>
      <div class="yanse"><el-progress :stroke-width="18" :show-text="false" :percentage="percentage"
          :color="customColors"></el-progress>
      </div>
      <span class="sptxt">您的易受骗类型：</span>
    </div>
    <el-row class="bba">
      <el-col :xs="24" :sm="12" :md="6" :lg="6" v-for="(imgurl, index) in images" :key="index">
        <el-card :body-style="{ padding: '14px' }" shadow="never">
          <el-image :src="imgurl.img_url" fit="contain" style="width: 180px; height: 180px;"
            :preview-src-list="[imgurl.img_url]"></el-image>

          <div style="padding: 0px;">
            <span class="sptit">{{ imgurl.category_name }}</span>
            <div class="bottom clearfix">
              <!-- <time class="time">{{ currentDate }}</time> -->
              <el-button type="text" class="buttontxt" icon="el-icon-thumb"
                @click="goto_externalurl(imgurl.video_url[0])">查看视频</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div class="ewmcon">
      <div class="fzcon">
        <el-image :src="xcm_ts_url" fit="contain" style="width: 100px; height: 100px;"
          :preview-src-list="[xcm_ts_url]"></el-image>
        <div class="catit"><i class="el-icon-copy-document"></i><span>长按保存此手册</span></div>
      </div>
      <div class="fzcon">
        <el-image :src="gjfzurl" fit="contain" style="width: 100px; height: 100px;"
          :preview-src-list="[gjfzurl]"></el-image>
        <div class="catit"><span>&nbsp;&nbsp;识别二维码关注国家反诈中心</span></div>
      </div>
    </div>
  </div>

</template>

<script>
import Tubiao from "./tubiao.vue";
export default {
  components: {
    Tubiao
  },
  props: {
    //添加移动端弹框宽度属性，默认为80%
    mobileEndWidth: {
      default: '80%',
      type: String
    },
  },
  data() {
    return {
      // 新增用户设备是移动端的属性
      userAgentMobile: '',
      currentDate: new Date(),
      paper: {
        tName: '您的专属反诈手册'
      },
      push_category_ids: '',
      score: '',
      color_name: '',
      url_dz: '',
      xcm_ts_url: '',
      images: [],
      showViewer: false,
      percentage: 10,
      customColors: [
        { color: 'blue', percentage: 25 },
        { color: 'yellow', percentage: 50 },
        { color: 'orange', percentage: 75 },
        { color: 'red', percentage: 100 }
      ],
      fz_url: require('../../assets/img/fzzximg.png'),
      gjfzurl: require('../../assets/img/fzurl.png'),
    };
  },
  computed: {
    style() {
      let style = {};
      if (!this.fullscreen) {
        style.marginTop = this.top;
        if (!this.userAgentMobile) { // pc端时
          if (this.width) { // 传入的width属性有值
            style.width = this.width; // 弹框宽度为width定义的宽度
          }
        } else { // 移动端
          style.width = this.mobileEndWidth // 移动端窗口宽度属性的值
        }
      }
      return style;
    }
  },

  created() {
    this.userAgentMobile = window.innerWidth <= 720 // 检测当前屏幕大小是移动端
    // console.log(this.$route.query.uid);
    // console.log(this.$route.query.tName);
    this.push_category_ids = this.$route.query.push_category_ids;
    // this.score = this.$route.query.score;
    this.color_name = this.$route.query.color_name;
    // this.paper.tName = this.$route.query.tName;
    this.url_dz = window.location.href;
    // console.log(this.url_dz);  
    //获取推送结果展示
    this.color_zs();
    this.get_result();
    this.handCheck();
  },

  methods: {
    get_result() {
      let data = this.$qs.stringify({
        push_category_ids: this.push_category_ids,

      });
      //显示loading
      this.bus.$emit("loading", true);
      this.$axios({
        method: "post",
        url: "/public/index.php/Index/publicize_push",
        data: data
      })
        .then(res => {
          if (res.data.code == 200) {
            // console.log(res.data.data)
            this.images = res.data.data;
            //关闭loading
            this.bus.$emit("loading", false);
          } else {
            //关闭loading
            this.bus.$emit("loading", false);
            // this.$message.error(res.data.message);
            this.$toast(res.data.message, 2000);
          }
        })
        .catch(err => {
          // this.$message.error(err);
          this.$toast(err, 2000);
        });
    },

    color_zs() {
      if (this.color_name == '蓝色') {
        this.percentage = 24;
      } else if (this.color_name == '黄色') {
        this.percentage = 49;
      } else if (this.color_name == '橙色') {
        this.percentage = 74;
      } else if (this.color_name == '红色') {
        this.percentage = 99;
      } else {
        this.percentage = 0;
      }
    },

    handCheck() {
      let data = this.$qs.stringify({
        url_dz: this.url_dz,

      });
      //显示loading
      // this.bus.$emit("loading", true);
      this.$axios({
        method: "post",
        url: "/public/index.php/Index/xcm_ts_ewm",
        data: data
      })
        .then(res => {
          if (res.data.code == 200) {
            // console.log(res.data)
            this.xcm_ts_url = res.data.data;
            //关闭loading
            // this.bus.$emit("loading", false);
          } else {
            //关闭loading
            // this.bus.$emit("loading", false);
            // this.$message.error(res.data.message);
            this.$toast(res.data.message, 2000);
          }
        })
        .catch(err => {
          // this.$message.error(err);
          this.$toast(err, 2000);
        });
    },

    goto_externalurl(url) {
       window.location.href = url;
      //console.log(url);
    }

  },


}

</script>

<style scoped lang="less">
.phone-container {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/img/111.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow-x: hidden;
  overflow-y: auto;

  .bodytitle {
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 13%;

    >span {

      font-family: YouSheBiaoTiHei;
      font-size: 5.2vh;

      letter-spacing: 0;
      font-weight: 400;
      background-image: -webkit-linear-gradient(bottom, #67b5a3, #55c5ad);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: -4px 2px 2px rgba(68, 188, 255, 0.3);
    }
  }

  .sptxt {
    font-family: 'PingFang Heavy';
    font-size: 2.6vh;
  }

  .sptit {
    font-family: 'PingFang Heavy';
    font-size: 2.6vh;
  }

  .ewmcon {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  .catit {
    font-family: 'PingFang Heavy';
    font-size: 2vh;
    margin-bottom: 5vw;
    line-height: 20px;

    img {
      width: 16px;
      height: 16px;

    }

    span {}
  }

  .bba {
    display: flex;
    justify-content: center;
    flex-direction: column;

  }

  .el-card {
    background: none !important;
    border: none !important;
  }
}


.el-image {
  margin-bottom: 18px;
  /* 图片之间的间隔 */
}

h2 {
  text-align: center;
  font-size: 28px;
  margin-bottom: 40px;
}



.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 18px;
  line-height: 12px;
}

.buttontxt {
  padding: 0;
  float: right;
  color: #0263c5;
  font-size: 2.3vh;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.renge {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

span {
  height: 30px;
}

.yanse {
  width: 200px;
  height: 30px;
  margin-bottom: 25px;
}

.fzcon {
  // display: flex;
  // justify-content: center;
  margin: 6vw 0 6vw 0;
}
</style>
